import { API_URL } from "../../../../constants";
import * as httpNetworking from "../../../../httpNetworking";

const URL = API_URL + "/user/billing/portal";
const VERSION = 0;

export async function getStripePortalSession(params: {
    returnURL: string;
}): Promise<{
    stripePortalLink: string | null;
    paymentInfoShared: boolean;
}> {
    const options: httpNetworking.GETRequestConfig = {
        timeout: 50000,
        params: params
    };

    const result = await httpNetworking.simpleGETRequest(URL, options, VERSION);
    return result.data;
}
